import { render, staticRenderFns } from "./EmailNotification.vue?vue&type=template&id=6eff0a7f&scoped=true"
import script from "./EmailNotification.vue?vue&type=script&lang=js"
export * from "./EmailNotification.vue?vue&type=script&lang=js"
import style0 from "./EmailNotification.vue?vue&type=style&index=0&id=6eff0a7f&prod&lang=css"
import style1 from "./EmailNotification.vue?vue&type=style&index=1&id=6eff0a7f&prod&lang=scss&scoped=true"
import style2 from "./EmailNotification.vue?vue&type=style&index=2&id=6eff0a7f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eff0a7f",
  null
  
)

export default component.exports